import { createLazyComponent, LazyModule, registerLazyOrchestrator } from 'owa-bundling';
import {
    exitSearch,
    getSuggestions,
    onSearchScopeOptionSelected,
    searchBoxBlurred,
    searchSessionEnded,
    searchSessionStarted,
    startSearch,
    suggestionSelected,
} from 'owa-search-actions';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CalendarSearch" */ './lazyIndex')
);

// Register lazy orchestrators
registerLazyOrchestrator(exitSearch, lazyModule, m => m.exitSearchOrchestrator);
registerLazyOrchestrator(startSearch, lazyModule, m => m.startSearchOrchestrator);
registerLazyOrchestrator(getSuggestions, lazyModule, m => m.getSuggestionsOrchestrator);
registerLazyOrchestrator(
    onSearchScopeOptionSelected,
    lazyModule,
    m => m.onSearchScopeOptionSelectedOrchestrator
);
registerLazyOrchestrator(searchBoxBlurred, lazyModule, m => m.searchBoxBlurredOrchestrator);
registerLazyOrchestrator(searchSessionEnded, lazyModule, m => m.searchSessionEndedOrchestrator);
registerLazyOrchestrator(searchSessionStarted, lazyModule, m => m.searchSessionStartedOrchestrator);
registerLazyOrchestrator(suggestionSelected, lazyModule, m => m.suggestionSelectedOrchestrator);

// Export components
export { default as CalendarSearchBoxContainer } from './components/CalendarSearchBoxContainer';

// Export lazy loaded components
export const CalendarSearchRefiners = createLazyComponent(
    lazyModule,
    m => m.CalendarSearchRefiners
);

export const AccountScopePicker = createLazyComponent(lazyModule, m => m.AccountScopePicker);
